import axios from 'axios';

const BASE_URL = 'https://mototaksi.az:9999/api/v6/carx';

const CarxController = {
  // Bütün qalibləri (Carx) gətir
  getAllCarx: async () => {
    try {
      const response = await axios.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Qaliblər alınarkən xəta:', error);
      throw error;
    }
  },

  // ID-yə görə qalib məlumatı gətir
  getCarxById: async (carxId) => {
    try {
      const response = await axios.get(`${BASE_URL}/${carxId}`);
      return response.data;
    } catch (error) {
      console.error(`Carx ID ${carxId} alınarkən xəta:`, error);
      throw error;
    }
  },

  // Yeni qalib manual olaraq yarat
  createCarx: async (carxData) => {
    try {
      const response = await axios.post(BASE_URL, carxData);
      return response.data;
    } catch (error) {
      console.error('Yeni Carx yaradılarkən xəta:', error);
      throw error;
    }
  },

  // Qalibi yenilə
  updateCarx: async (carxId, carxData) => {
    try {
      const response = await axios.put(`${BASE_URL}/${carxId}`, carxData);
      return response.data;
    } catch (error) {
      console.error(`Carx ID ${carxId} yenilənərkən xəta:`, error);
      throw error;
    }
  },

  // Qalibi sil
  deleteCarxById: async (carxId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${carxId}`);
      return response.data;
    } catch (error) {
      console.error(`Carx ID ${carxId} silinərkən xəta:`, error);
      throw error;
    }
  },

  // Lotoreya üçün random qalib təyin et
  assignWinner: async (lotoreyaId, codes) => {
    try {
      const response = await axios.post(`${BASE_URL}/assign`, {
        lotoreyaId,
        codes, // burada artıq `codes` parametri daxil edilir
      });
      return response.data;
    } catch (error) {
      console.error("Qalib təyinatında xəta:", error);
      return null;
    }
  }

};

export default CarxController;

